import { render, staticRenderFns } from "./noresult.vue?vue&type=template&id=1658840d&"
import script from "./noresult.vue?vue&type=script&lang=js&"
export * from "./noresult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports